<template>
  <div class="tab-container mb-3">
    <nav class="flex flex-row flex-wrap">
      <tab-select
        v-if="tabs.length === 0"
        class="tab tab-active"
        :name="$t('message.changeRace')"
        :items="results"
        :item-text="(item) => getTitle(item)"
        :on-select="(item) => onTabSelect(item, tab)"
        :selected="selectedRace"
        :show-dashboard-map="showDashboardMap" />
      <template
        v-for="[tab, items] in tabList"
        v-else
        :key="tab">
        <tab-select
          :class="['tab mr', selectedTab === tab ? 'tab-active' : '']"
          :name="getName(tab)"
          :items="items"
          :item-text="(item) => getTitle(item, tab)"
          :on-select="(item) => onTabSelect(item, tab)"
          :show-dashboard-map="showDashboardMap"
          :selected="selectedRace" />
      </template>
    </nav>
  </div>
</template>

<script>
import { getTabName, getTabTitle } from "@/helpers/titles";
import { mapActions } from "vuex";

import TabSelect from "./TabSelect";

export default {
  components: {
    TabSelect,
  },
  props: {
    results: {
      type: Array,
      required: true,
    },
    tabs: {
      type: Array,
      required: true,
    },
    selectedRace: {
      default: undefined,
      type: Number,
      required: false,
    },
    selectedTab: {
      default: undefined,
      type: String,
      required: false,
    },
    showDashboardMap: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["change"],
  data: () => ({
    sameOffice: false,
    sameState: false,
    selected: 0,
    tabList: null,
  }),
  beforeMount() {
    this.sameState = [...this.results]
      .map((r) => r.state)
      .every((s) => s === this.results[0].state);
    this.sameOffice = [...this.results]
      .map((r) => r.office)
      .every((s) => s === this.results[0].office);
    this.createTabs();
  },
  methods: {
    ...mapActions(["setGeoSelection", "setSelectedResultIndex"]),
    onTabSelect(item, office) {
      let index;
      if (!item) index = null;
      else {
        const obj = this.results.find((r) => r.race_id === item.race_id);
        index = this.results.indexOf(obj);
        this.$emit("change", office);
        this.selected = item ? item.race_id : 0;
      }
      this.setGeoSelection(null);
      this.setSelectedResultIndex(index);
    },
    createTabs() {
      this.tabList = new Map();
      let results = [...this.results];
      this.tabs.forEach((tab) => {
        const items = results.filter((r) => r.office === tab || r.name === tab);
        results = results.filter((r) => !items.map((i) => i.race_id).includes(r.race_id));
        this.tabList.set(tab, items);
      });
      if (results.length > 0) {
        this.tabList.set("More", results);
      }
    },
    getTitle(item, tab) {
      const hideState = this.sameState;
      const hideOffice = (this.sameState && this.sameOffice) || tab;

      return getTabTitle(item, hideState, hideOffice);
    },
    getName(tab) {
      return getTabName(tab);
    },
  },
};
</script>

<style>
.tab {
  @apply focus:outline-none mr-5 block text-sm;

  color: var(--dem-color);
}

.tab:hover {
  color: #3b558e;
}

.tab-active {
  @apply whitespace-nowrap font-bold;
}

@media screen and (max-width: 700px) {
  .tab-container {
    @apply w-full;
  }
}
</style>
